import { useEffect, useState } from "react";

/** Absent key means the current app. "on" makes `/` the new dashboard. */
export const EXPERIMENTAL_MODE_KEY = "ft-experimental-mode";

const CHANGE_EVENT = "ft-experimental-mode";

export function readExperimentalMode() {
  try {
    return localStorage.getItem(EXPERIMENTAL_MODE_KEY) === "on";
  } catch {
    return false;
  }
}

export function writeExperimentalMode(on) {
  try {
    if (on) localStorage.setItem(EXPERIMENTAL_MODE_KEY, "on");
    else localStorage.removeItem(EXPERIMENTAL_MODE_KEY);
  } catch {
    // Private browsing can block storage. The in-memory listeners still update.
  }
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

export function useExperimentalMode() {
  const [on, setOn] = useState(readExperimentalMode);

  useEffect(() => {
    const sync = () => setOn(readExperimentalMode());
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return on;
}
